export const GET_ACCOUNT_BY_TYPE = 'GET_ACCOUNT_BY_TYPE'

export const GET_ACCOUNT_BY_ID = 'GET_ACCOUNT_BY_ID'
export const GET_ACCOUNT_BY_ID_PENDING = 'GET_ACCOUNT_BY_ID_PENDING'
export const GET_ACCOUNT_BY_ID_FULFILLED = 'GET_ACCOUNT_BY_ID_FULFILLED'
export const GET_ACCOUNT_BY_ID_ERROR = 'GET_ACCOUNT_BY_ID_ERROR'

export const GET_ACCOUNT_ORDER_BY_ID = 'GET_ACCOUNT_ORDER_BY_ID'
export const GET_SERVICES_BY_ACCOUNT = 'GET_SERVICES_BY_ACCOUNT'
export const GET_ORDERS_BY_ACCOUNT = 'GET_ORDERS_BY_ACCOUNT'
export const GET_CANCELLED_ORDERS_BY_ACCOUNT = 'GET_CANCELLED_ORDERS_BY_ACCOUNT'
export const GET_COMPLETED_ORDERS_BY_ACCOUNT = 'GET_COMPLETED_ORDERS_BY_ACCOUNT'
export const GET_PENDING_ORDERS_BY_ACCOUNT = 'GET_PENDING_ORDERS_BY_ACCOUNT'
export const GET_EMAILS_BY_ACCOUNT = 'GET_EMAILS_BY_ACCOUNT'
export const GET_PAYPAL_TRANSACTIONS = 'GET_PAYPAL_TRANSACTIONS'
export const GET_PAYPAL_NEW_TRANSACTIONS = 'GET_PAYPAL_NEW_TRANSACTIONS'
export const POST_DOMAIN_MIGRATE = 'POST_DOMAIN_MIGRATE'
export const POST_DOMAIN_SWAP = 'POST_DOMAIN_SWAP'
export const ENABLE_LOCAL_DEBUG = 'ENABLE_LOCAL_DEBUG'
export const RESTORE_SERVICE = 'RESTORE_SERVICE'
export const POST_DELETE_DOMAIN = 'POST_DELETE_DOMAIN'

export const CANCEL_ORDER_BY_ID = 'CANCEL_ORDER_BY_ID'
export const CANCEL_ORDER_BY_ID_PENDING = 'CANCEL_ORDER_BY_ID_PENDING'
export const CANCEL_ORDER_BY_ID_FULFILLED = 'CANCEL_ORDER_BY_ID_FULFILLED'
export const CANCEL_ORDER_BY_ID_ERROR = 'CANCEL_ORDER_BY_ID_ERROR'

export const APPROVE_ORDER_BY_ID = 'APPROVE_ORDER_BY_ID'
export const APPROVE_ORDER_BY_ID_PENDING = 'APPROVE_ORDER_BY_ID_PENDING'
export const APPROVE_ORDER_BY_ID_FULFILLED = 'APPROVE_ORDER_BY_ID_FULFILLED'
export const APPROVE_ORDER_BY_ID_ERROR = 'APPROVE_ORDER_BY_ID_ERROR'

export const GET_FREE_DOMAIN_AVAILABLE = 'GET_FREE_DOMAIN_AVAILABLE'
export const GET_FREE_DOMAIN_AVAILABLE_PENDING = 'GET_FREE_DOMAIN_AVAILABLE_PENDING'
export const GET_FREE_DOMAIN_AVAILABLE_FULFILLED = 'GET_FREE_DOMAIN_AVAILABLE_FULFILLED'
export const GET_FREE_DOMAIN_AVAILABLE_ERROR = 'GET_FREE_DOMAIN_AVAILABLE_ERROR'

export const GET_FREE_EMAIL_AVAILABLE = 'GET_FREE_EMAIL_AVAILABLE'
export const GET_FREE_EMAIL_AVAILABLE_PENDING = 'GET_FREE_EMAIL_AVAILABLE_PENDING'
export const GET_FREE_EMAIL_AVAILABLE_FULFILLED = 'GET_FREE_EMAIL_AVAILABLE_FULFILLED'
export const GET_FREE_EMAIL_AVAILABLE_ERROR = 'GET_FREE_EMAIL_AVAILABLE_ERROR'

export const POST_CHANGE_EMAIL = 'POST_CHANGE_EMAIL'
export const POST_CHANGE_EMAIL_PENDING = 'POST_CHANGE_EMAIL_PENDING'
export const POST_CHANGE_EMAIL_FULFILLED = 'POST_CHANGE_EMAIL_FULFILLED'
export const POST_CHANGE_EMAIL_ERROR = 'POST_CHANGE_EMAIL_ERROR'

export const CREATE_EXTERNAL_ACCOUNT = 'CREATE_EXTERNAL_ACCOUNT'
export const CREATE_EXTERNAL_ACCOUNT_PENDING = 'CREATE_EXTERNAL_ACCOUNT_PENDING'
export const CREATE_EXTERNAL_ACCOUNT_FULFILLED = 'CREATE_EXTERNAL_ACCOUNT_FULFILLED'
export const CREATE_EXTERNAL_ACCOUNT_ERROR = 'CREATE_EXTERNAL_ACCOUNT_ERROR'

export const SYNCHRONIZE_CARDS = 'SYNCHRONIZE_CARDS'
export const SYNCHRONIZE_CARDS_PENDING = 'SYNCHRONIZE_CARDS_PENDING'
export const SYNCHRONIZE_CARDS_FULFILLED = 'SYNCHRONIZE_CARDS_FULFILLED'
export const SYNCHRONIZE_CARDS_ERROR = 'SYNCHRONIZE_CARDS_ERROR'

export const GET_LOGOUT = 'GET_LOGOUT'
export const GET_LOGOUT_FULFILLED = 'GET_LOGOUT_FULFILLED'

export const GET_DNS_BY_ID = 'GET_DNS_BY_ID'
export const GET_DOMAIN_BY_ID = 'GET_DOMAIN_BY_ID'
export const TRANSFER_DOMAIN_BY_NAME = 'TRANSFER_DOMAIN_BY_NAME'
export const POST_DNS_BY_ID = 'POST_DNS_BY_ID'
export const MODIFY_DNS = 'MODIFY_DNS'
export const POST_RENEWAL_REPORT = 'POST_RENEWAL_REPORT'
export const GET_USERS_FOR_THEIR_ROLES = 'GET_USERS_FOR_THEIR_ROLES'
export const GET_AGENT_EVENTS_BY_ACCOUNT = 'GET_AGENT_EVENTS_BY_ACCOUNT'
export const GET_PASSWORD_RESET_EVENTS_BY_ACCOUNT = 'GET_PASSWORD_RESET_EVENTS_BY_ACCOUNT'
export const GET_LOGIN_EVENTS_BY_ACCOUNT = 'GET_LOGIN_EVENTS_BY_ACCOUNT'
export const GET_UBERSMITH_EVENTS_BY_UBERCLIENTID = 'GET_UBERSMITH_EVENTS_BY_UBERCLIENTID'
export const GET_SDN_EVENTS_BY_ACCOUNT = 'GET_SDN_EVENTS_BY_ACCOUNT'
export const GET_FOLLOW_UPS = 'GET_FOLLOW_UPS'
export const POST_IMAGE = 'POST_IMAGE'
export const POST_ALLOW_MAIL_PURCHASES = 'POST_ALLOW_MAIL_PURCHASES'
export const POST_ALLOW_DOMAIN_PURCHASES = 'POST_ALLOW_DOMAIN_PURCHASES'
export const POST_ALLOW_CHANGE_PAYMENT_METHOD = 'POST_ALLOW_CHANGE_PAYMENT_METHOD'
export const GET_COMMENTS_BY_ACCOUNT = 'GET_COMMENTS_BY_ACCOUNT'
export const PUT_UPDATE_COMMENT = 'PUT_UPDATE_COMMENT'
export const GET_UBERSMITH_COMMENTS_BY_UBERCLIENTID = 'GET_UBERSMITH_COMMENTS_BY_UBERCLIENTID'
export const FILTER_COMMENTS = 'FILTER_COMMENTS'
export const RESET_FILTER_COMMENTS_RESPONSE = 'RESET_FILTER_COMMENTS_RESPONSE'

export const GET_NAMESERVERS_BY_DOMAIN_ID = 'GET_NAMESERVERS_BY_DOMAIN_ID'
export const UPDATE_NAMESERVERS_FOR_DOMAIN = 'UPDATE_NAMESERVERS_FOR_DOMAIN'
export const UPDATE_NAMESERVERS_FOR_DOMAIN_FULFILLED = 'UPDATE_NAMESERVERS_FOR_DOMAIN_FULFILLED'
export const UPDATE_NAMESERVERS_FOR_DOMAIN_PENDING = 'UPDATE_NAMESERVERS_FOR_DOMAIN_PENDING'
export const UPDATE_NAMESERVERS_FOR_DOMAIN_ERROR = 'UPDATE_NAMESERVERS_FOR_DOMAIN_ERROR'

export const GET_CHANGE_TARGETS = 'GET_CHANGE_TARGETS'
export const CHANGE_SERVICE = 'CHANGE_SERVICE'

export const ADD_SERVICE = 'ADD_SERVICE'
export const RESET_ADD_SERVICE_RESPONSE = 'RESET_ADD_SERVICE_RESPONSE'

export const GET_PARTNERS = 'GET_PARTNERS'
export const CREATE_NEW_ACCOUNT_TEST_TOOL = 'CREATE_NEW_ACCOUNT_TEST_TOOL'
export const GET_ACCOUNT_TEST_TOOL = 'GET_ACCOUNT_TEST_TOOL'
export const GET_SITES_TEST_TOOL = 'GET_SITES_TEST_TOOL'
export const CREATE_NEW_SITE_TEST_TOOL = 'CREATE_NEW_SITE_TEST_TOOL'
export const GENERATE_TOKEN_TEST_TOOL = 'GENERATE_TOKEN_TEST_TOOL'
export const RESET_TEST_TOOL = 'RESET_TEST_TOOL'
export const RESET_TEST_TOOL_ERROR = 'RESET_TEST_TOOL_ERROR'

export const ADD_CREDITS = 'ADD_CREDITS'
export const ACCOUNT_RELINK = 'ACCOUNT_RELINK'

export const GET_DOMAIN_RENEWAL_LOGS = 'GET_DOMAIN_RENEWAL_LOGS'

export const GET_GOODWILL_CREDITS_FOR_ACCOUNT = 'GET_GOODWILL_CREDITS_FOR_ACCOUNT'

export const REMOVE_FREE_DOMAIN_CREDIT = 'REMOVE_FREE_DOMAIN_CREDIT'

export const CANCEL_MULTIPLE_SERVICES = 'CANCEL_MULTIPLE_SERVICES'
export const CANCEL_MULTIPLE_SERVICES_PENDING = 'CANCEL_MULTIPLE_SERVICES_PENDING'
export const CANCEL_MULTIPLE_SERVICES_FULFILLED = 'CANCEL_MULTIPLE_SERVICES_FULFILLED'

export const GET_REGISTERED_DOMAINS = 'GET_REGISTERED_DOMAINS'

export const CANCEL_ACCOUNT = 'CANCEL_ACCOUNT'
export const CANCEL_ACCOUNT_FULFILLED = 'CANCEL_ACCOUNT_FULFILLED'
export const CANCEL_ACCOUNT_RESET = 'CANCEL_ACCOUNT_RESET'

export const RESTORE_ACCOUNT = 'RESTORE_ACCOUNT'
export const RESTORE_ACCOUNT_FULFILLED = 'RESTORE_ACCOUNT_FULFILLED'

export const DOWNGRADE_ACCOUNT = 'DOWNGRADE_ACCOUNT'
export const DOWNGRADE_ACCOUNT_FULFILLED = 'DOWNGRADE_ACCOUNT_FULFILLED'

export const SUSPEND_DOMAIN = 'SUSPEND_DOMAIN'
export const SUSPEND_DOMAIN_PENDING = 'SUSPEND_DOMAIN_PENDING'
export const UNSUSPEND_DOMAIN = 'UNSUSPEND_DOMAIN'
export const UNSUSPEND_DOMAIN_PENDING = 'UNSUSPEND_DOMAIN_PENDING'

export const ENABLE_PRIVACY_PROTECTION = 'ENABLE_PRIVACY_PROTECTION'
export const DISABLE_PRIVACY_PROTECTION = 'DISABLE_PRIVACY_PROTECTION'

export const ENABLE_THEFT_PROTECTION = 'ENABLE_THEFT_PROTECTION'
export const DISABLE_THEFT_PROTECTION = 'DISABLE_THEFT_PROTECTION'

export const GET_REFUNDABLE_SERVICES = 'GET_REFUNDABLE_SERVICES'

export const POST_REFUND_SERVICES = 'POST_REFUND_SERVICES'
export const POST_REFUND_SERVICES_PENDING = 'POST_REFUND_SERVICES_PENDING'
export const POST_REFUND_SERVICES_FULFILLED = 'POST_REFUND_SERVICES_FULFILLED'
export const POST_REFUND_SERVICES_ERROR = 'POST_REFUND_SERVICES_ERROR'

export const CANCEL_SERVICE = 'CANCEL_SERVICE'
export const CANCEL_SERVICE_PENDING = 'CANCEL_SERVICE_PENDING'
export const CANCEL_SERVICE_FULFILLED = 'CANCEL_SERVICE_FULFILLED'

export const POST_SINGLEPLATFORM_LOCATION = 'POST_SINGLEPLATFORM_LOCATION'
export const POST_SINGLEPLATFORM_LOCATION_RESET = 'POST_SINGLEPLATFORM_LOCATION_RESET'

export const ADD_USER_ROLES = 'ADD_USER_ROLES'
export const REMOVE_USER_ROLES = 'REMOVE_USER_ROLES'
